export default "__VITE_ASSET__BRFIMsDi__"